<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <PrizesForm :basePrize="prize" :basePrizeName="name" :loading="loading" @submit-requested="submitRequested"></PrizesForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PrizesForm from './PrizesForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            prize: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { PrizesForm },
    computed:
    {
        ...mapState('prizes', ['getPrizeDetailsOutput']),
    },
    methods: {
        ...mapActions('prizes', ['getPrizeDetails']),
        ...mapActions('prizes', ['putPrize']),
        submitRequested(prize) {
            this.putPrize(prize);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'PrizesList' });
        }

        this.getPrizeDetails(this.$route.query.id);
    },
    watch:
    {
        getPrizeDetailsOutput: function(prizeOutput)
        {
            if(!prizeOutput && !prizeOutput.data)
            {
                router.push({ name: 'PrizesList' });
            }
            else
            {
                this.prize = prizeOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>